import {Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges} from '@angular/core';
import {PageLinkModel} from '../page-link.model';
import {ActivatedRoute, Params} from '@angular/router';
import {PageLinkFilterLabel} from '../page-link-filter-label';
import {HttpClient} from '@angular/common/http';
import {forkJoin, Observable} from 'rxjs';
import {of} from 'rxjs/internal/observable/of';

@Component({
  selector: 'app-form-links',
  templateUrl: './form-links.component.html',
  styleUrls: ['./form-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormLinksComponent implements OnInit, OnChanges {

  @Input() limit = -1;
  @Input() pageLinks: PageLinkModel[] = [];
  @Input() resolve: Params = {};
  /**
   * Набор меток, которые нужно фильтровать
   * в виде массива объектов с булевыми значениями
   * true - фильтровать
   * false|undefined - не фильтровать
   * [
   *  {
   *   label: [labelValue],
   *   filter: true|false|undefined
   *  }
   * ]
   *
   * Пример:
   * [
   *  {
   *   label: 'deviceparams'
   *   filter: true;
   *  }
   * ]
   */
  @Input() filterLabels: PageLinkFilterLabel[] = [];
  bindFilterLabels = this.filterByLabels.bind(this);

  constructor(private route: ActivatedRoute, private http: HttpClient) {
  }

  ngOnInit() {
    return;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateLinksCount();
  }

  updateLinksCount() {
    this.pageLinks.forEach(_pl => {
      if (_pl.countUrl && (typeof _pl.countUrl === 'string' || Array.isArray(_pl.countUrl))) {
        if(Array.isArray(_pl.countUrl)){
          _pl.count = new Observable(subscriber => {
            let list = [];
            (_pl.countUrl as any).forEach(url => {
              list.push(this.http.get<number>(this.resolveUrl(url)));
            });
            forkJoin(list).subscribe(data => {
              //console.log(data?.constructor?.name);
              let result = 0;
              data.forEach(res => {
                if (res && res.constructor.name === 'Number') {
                  result += res;
                } else if(res && res.constructor.name === 'Array') {
                  result += (res as any).length;
                }
              });
              subscriber.next(result);
              subscriber.complete();
            }, e => subscriber.error(e));
          });

        } else {
          _pl.count = new Observable(subscriber => {
            this.http.get<number>(this.resolveUrl(_pl.countUrl)).subscribe(data => {
              //console.log(data?.constructor?.name);
              if (data && data.constructor.name === 'Number') {
                subscriber.next(data);
              } else if(data && data.constructor.name === 'Array') {
                subscriber.next((data as any).length);
              } else {
                subscriber.next(0);
              }

              subscriber.complete();
            }, e => subscriber.error(e));
          });

        }
      } else if (_pl.countUrl && typeof _pl.countUrl === 'number') {
        _pl.count = of (_pl.countUrl);
      }
    });
  }

  resolveUrl(url: string): string {
    let resolvedUrl = url;
    Object.keys(this.resolve).forEach(_key => {
      if (this.resolve[_key]) {
        resolvedUrl = resolvedUrl.replace(`:${_key}`, this.resolve[_key]);
      }
    });
    Object.keys(this.route.snapshot.params).forEach(_key => {
      if (this.route.snapshot.params[_key]) {
        resolvedUrl = resolvedUrl.replace(`:${_key}`, this.route.snapshot.params[_key]);
      }
    });
    Object.keys(this.route.parent.snapshot.params).forEach(_key => resolvedUrl = resolvedUrl.replace(`:${_key}`, this.route.parent.snapshot.params[_key]));
    return resolvedUrl;
  }

  resolveQueryParams(params: {}): {} {
    if (params) {
      const resolvedparams = {};
      Object.keys(this.resolve).forEach(_key => {
        if (this.resolve[_key] && params[_key]) {
          resolvedparams[params[_key]] = this.resolve[_key];
        }
      });
      return resolvedparams;
    }
  }

  filterByLabels(data) {
    return (this.filterLabels.find(_filter => _filter.label === data.label) || {label: 'any', isShow: true}).isShow;
  }

}
